export type GrantsfinanceBoilerType = {
  src: string;
  title: string;
  content: string;
};
export type GrantsfinanceSolarType = {
  src: string;
  title: string;
  content: string;
  list: string[];
};

export const GrantsBoiler: GrantsfinanceBoilerType[] = [
  {
    src: "images/checkout-success/logo-seai.webp",
    title: "Grants",
    content:
      "The Sustainable Energy Authority of Ireland are currently offering home owners grants of up to €750 for upgrading your property with heating controls."
  }
];
export const FinanceBoiler: GrantsfinanceBoilerType[] = [
  {
    src: "images/checkout-success/logo-hum.webp",
    title: "Finance",
    content:
      "Swyft Energy has teamed up with Humm so you can buy now and pay later. You have full control to your own humm account and you can pay out early with no additional fees."
  }
];

export const GrantsSolar: GrantsfinanceSolarType[] = [
  {
    src: "images/checkout-success/logo-seai.webp",
    title: "Grants",
    content:
      "If your eligible for the seai grant, we take the following steps to make sure your grant is submitted successfully.",
    list: [
      "We complete your NC6 form to qualify you for the feed-in-tariff.",
      "We guide you step-by-step through the grant application.",
      "We manage the application process, and liase with the SEAI on your behalf.",
      "Following your installation we organise your BER assessment.",
      "We gather all necessary documentation and submit your grant to the SEAI."
    ]
  }
];
export const FinanceSolar: GrantsfinanceSolarType[] = [
  {
    src: "images/checkout-success/logo-finance.webp",
    title: "Finance",
    content:
      "By partnering with Finance ireland, Swyft Energy customers can now avail of a hassle-free finance offering, with lending terms from 2-10 years, and covering all budgets with finance available from €4,000 to €25,000.",
    list: [
      "Full online application process",
      "Credit decision within 24 hours",
      "Competitive interest rate of 6.7%",
      "Option to borrow up to 10 years at the same rate",
      "20% in additional funds can be paid to the customer"
    ]
  }
];
